<template>
  <div v-if="upgradableLicenseSubmissions.length > 0">

    <div style="margin-bottom:12px">
      Alternatively, you may also customize media rights for each of your existing films.
    </div>

    <el-card
      class="fla__card"
    >
    <h3>Media Rights</h3>
      <MediaSubmissionTable
        :submissions="upgradableLicenseSubmissions"
        @change="submissionTableChange"
      />
    </el-card>
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import MediaSubmissionTable from './MediaSubmissionTable';

const AGREEMENT_FORM_CONSTANT = {
  RIGHTS_MEDIA: {
    MEDIA_ALL: 'MEDIA_ALL',
    MEDIA_EXCLUDE_BROADCAST_TV: 'MEDIA_EXCLUDE_BROADCAST_TV',
  },
};

export default {
  components: {
    MediaSubmissionTable,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCustomisationForEachFilm: false,
      upgradableLicenseSubmissions: [],
      originalLicenseSubmissions: [],
    };
  },
  computed: {
    selectedMediaRights() {
      return this.licenseRendererVm.form.mediaRights.value;
    },
  },
  watch: {
    selectedMediaRights(newValue) {
      if (newValue) {
        this.upgradableLicenseSubmissions.forEach((submission) => {
          submission.rights_media = newValue;
        });
        this.updateValue(this.upgradableLicenseSubmissions);
      }
    },
    showCustomisationForEachFilm(newValue) {
      if (!newValue) {
        this.enableMediaRightGlobalRadio();
      }
    },
  },
  mounted() {
    this.getUpgradableLicense()
      .then((upgradableLicenseSubmissions) => {
        // Hide mediaRights component if user does not have existing upgradable submission
        if (upgradableLicenseSubmissions.length <= 0) {
          this.licenseRendererVm.hideLicenseRenderer('mediaRights', true);
          return upgradableLicenseSubmissions;
        }
        // Prepare submission for display
        const processedSubmissions = this.prefillSubmissionProperties(upgradableLicenseSubmissions, {
          rights_media: AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL,
        });

        // Initialize UI based on display configuration
        this.initializeExternalUI(this.getDisplayConfiguration(processedSubmissions));
        return processedSubmissions;
      })
      .then((submissions) => {
        // Update parent and self
        this.upgradableLicenseSubmissions = submissions;
        this.updateValue(submissions);
      })
    ;
  },
  methods: {
    submissionTableChange([item, property, value]) {
      this.disableMediaRightGlobalRadio();
      this.updateValue(this.upgradableLicenseSubmissions);
    },
    disableMediaRightGlobalRadio() {
      this.licenseRendererVm.$parent.form.rights_media = '';
    },
    enableMediaRightGlobalRadio() {
      if (!this.licenseRendererVm.$parent.form.rights_media) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL;
      }
    },

    getUpgradableLicense() {
      return webcall.agreement.getUpgradableLicense({
        params: {
          per_page: 999,
          current_page: 0,
        },
      })
        .then(({ data }) => {
          this.originalLicenseSubmissions = data.videos;
          return data.videos;
        })
      ;
    },

    prefillSubmissionProperties(submissions, prefillOptions = {}) {
      return submissions.map((submission) => {
        const prefillObjects = Object.keys(prefillOptions)
          .map((prefillKey) => {
            const prefillValue = prefillOptions[prefillKey];
            const originalValue = submission[prefillKey];
            return [prefillKey, originalValue, prefillValue];
          })
          .reduce((acc, [prefillKey, originalValue, prefillValue]) => {
            if (!originalValue) {
              acc[prefillKey] = prefillValue;
            }
            return acc;
          }, {});

        return {
          ...submission,
          ...prefillObjects,
        };
      });
    },

    /**
     * Compute display configuration for the given submissions array
     */
    getDisplayConfiguration(submissions) {
      const displayConfiguration = submissions.reduce((collector, submission) => {
        /* eslint camelcase: 0 */
        collector.isEveryAll = collector.isEveryAll && (submission.rights_media === AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL);
        collector.isEveryExclude = collector.isEveryExclude && (submission.rights_media === AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_EXCLUDE_BROADCAST_TV);
        return collector;
      }, { isEveryAll: true, isEveryExclude: true });

      return displayConfiguration;
    },

    initializeExternalUI(displayConfiguration) {
      if (displayConfiguration.isEveryAll) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL;
      } else if (displayConfiguration.isEveryExclude) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_EXCLUDE_BROADCAST_TV;
      } else {
        this.disableMediaRightGlobalRadio();
        this.showCustomisationForEachFilm = true;
      }
    },

    updateValue(submissionsToBeUpdated) {
      const allSubmissionIdMap = this.originalLicenseSubmissions
        .reduce((acc, submission) => {
          acc[submission.id] = submission;
          return acc;
        }, {});

      // Update payload
      submissionsToBeUpdated.forEach((submission) => {
        allSubmissionIdMap[submission.id] = submission;
      });

      const payload = Object.keys(allSubmissionIdMap)
        .map(submissionId => allSubmissionIdMap[submissionId])
      ;

      this.$emit('input', payload);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourLicenseRenewalMedia/index.vue